import type { ReactNode } from 'react';

type Tone = 'primary' | 'accent' | 'secondary' | 'neutral';

const toneMap: Record<Tone, string> = {
  primary: 'bg-primary-500/15 text-primary-300 border-primary-500/30',
  accent: 'bg-accent-500/15 text-accent-300 border-accent-500/30',
  secondary: 'bg-secondary-500/15 text-secondary-200 border-secondary-500/30',
  neutral: 'bg-background-100 text-foreground-700 border-background-200',
};

interface TagProps {
  children: ReactNode;
  tone?: Tone;
  className?: string;
}

export default function Tag({ children, tone = 'neutral', className = '' }: TagProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs leading-none whitespace-nowrap ${toneMap[tone]} ${className}`}
    >
      {children}
    </span>
  );
}